module.exports = __webpack_public_path__ + "static/media/toggle-layer.70ee6513.svg";